import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { IParamsId } from "../../components/artist-profile-artworks/utils";
import ArtworksPageComponent from "../../components/artworks-page-component/ArtworksPageComponent";
import { useTypedSelector } from "../../hooks/useTypedSelector";

import "./ArtworksFoundProfile.scss";

const ArtworksFoundProfile = (): JSX.Element => {
  const { id }: IParamsId = useParams();
  const dispatch = useDispatch();
  const artworks = useTypedSelector(state => state.artworkSearchFilterReducer);
  return (
    <div className="artworks_found">
      <ArtworksPageComponent
        queryParams={{ ownerId: id, types: ["found"] }}
        context={{ dispatch, state: artworks }}
        title="Found Artworks"
        myMoca={false}
        shareMark={false}
        questionMark={false}
        backButton
        controlsPage
      />
    </div>
  );
};

export default ArtworksFoundProfile;
